import { postFetch } from '../fetch';
import { apiConfig } from '../config';

export interface CancelReactionRequest {
    reactionIds: string[];
}

export function cancelReactions(
    request: CancelReactionRequest
): Promise<void> {
    const { apiCancelReaction } = apiConfig.getStaticUrls();

    return postFetch(apiCancelReaction, {
        ids: request.reactionIds,
    });
}
